"use strict";
import AOS from "aos";
import main from "../css/sass/main.scss";
import inline from "../css/sass/inline.scss";
import mobileMenu from "./scripts/menu/mobileMenu";
import updateGridLinesHeight from "./scripts/updateGridLinesHeight";

import headerScrolling from "./scripts/headerScrolling";
import menuScroll from "./scripts/menu/menuScroll";
import clientsSlider from "./scripts/clientsSlider";
import casesSlider from "./scripts/casesSlider";
import peopleSlider from "./scripts/peopleSlider";
import awardSlider from "./scripts/awardSlider";
import challengesSlider from "./scripts/challengesSlider";
import lightBox from "./scripts/lightbox";

AOS.init({
    once: true,
});

headerScrolling();
mobileMenu();
updateGridLinesHeight();
clientsSlider();
casesSlider();
peopleSlider();
awardSlider();
menuScroll();
challengesSlider();
lightBox();
